const baseStyles = {
    containerBackground: {
        position: 'absolute',
        top: '0',
        width: '15%',
        height: '100%',
        maxWidth: '370px',
        backgroundRepeat: 'no-repeat',
        display: {base: 'none', xl: 'block'}
    }
}
export default {
    baseStyle: {
        largeContainer: {
            backgroundColor: {base: 'none', xl: 'primaryBgColor'},
            position: 'relative',
            maxWidth: 'container.2xl',
            width: '100%',
            margin: '0 auto',
            flex: '1'
        },

        containerBackgroundLeft: {
            ...baseStyles.containerBackground,
            left: '0'
        },
        containerBackgroundRight: {
            ...baseStyles.containerBackground,
            right: '0'
        },
        heading: {
            fontSize: '26px',
            lineHeight: '38px',
            fontWeight: '700',
            fontFamily: 'DM Sans'
        },
        subHeading: {
            fontSize: 'xl',
            lineHeight: '26px',
            fontWeight: '700',
            color: 'darkGunmetal',
            fontFamily: 'DM Sans'
        }
    },
    variants: {}
}
